<template>
  <div>
    <div class="row">
      <div class="col-lg-4">
        <h4 v-if="user.selector1 == 'Permanent' || user.selector1 == 'Interim'" class="pt-1">Additional Service Request</h4>
        <h4 v-else class="pt-1">Service Request</h4>
        <!-- {{ jobs }}
        <hr>
        {{ calendarJobs }} -->
        <hr>
        <div v-if="!selectedDate">
          <p>Please select a date.</p>
        </div>
        <div v-if="selectedDate">
          <p>{{ selectedDate.toDateString() }}</p>
          <!-- <p>{{ employers }}</p> -->
          <!-- <label style="margin-bottom: 0; margin-top: 10px;" for>Client</label>
          <multiselect
            class="mb-2 w-100"
            v-model="selectedFilterEmployer"
            :options="employers"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select Client"
          ></multiselect> -->
          <label style="margin-bottom: 0; margin-top: 10px;">Start Time</label>
          <div class="input-group">
            <select class="form-control" v-model="startHour">
              <!-- <option>HH</option> -->
              <option v-for="(hour, index) in hourOptions" :key="'StartHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="startMinute">
              <!-- <option>MM</option> -->
              <option v-for="(minute, index) in minuteOptions" :key="'StartMinute'+index">{{ minute }}</option>
            </select>
            <select class="form-control" v-model="startAMPM">
              <option v-for="(ampm, index) in ampmOptions" :key="'StartAMPM'+index">{{ ampm }}</option>
            </select>
          </div>
          <label style="margin-bottom: 0; margin-top: 12px;">End Time</label>
          <div class="input-group">
            <select class="form-control" v-model="endHour">
              <!-- <option>HH</option> -->
              <option v-for="(hour, index) in hourOptions" :key="'EndHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="endMinute">
              <!-- <option>MM</option> -->
              <option v-for="(minute, index) in minuteOptions" :key="'EndMinute'+index">{{ minute }}</option>
            </select>
            <select class="form-control" v-model="endAMPM">
              <option v-for="(ampm, index) in ampmOptions" :key="'EndAMPM'+index">{{ ampm }}</option>
            </select>
          </div>
          <label style="margin-bottom: 0; margin-top: 12px;">Preferred Nanny/Babysitter Name</label>
          <input type="text" class="form-control" v-model="preferredNanny" placeholder="Is there someone you would prefer?">
          <label style="margin-bottom: 0; margin-top: 12px;">Special Notes</label>
          <textarea rows="5" v-model="notes" class="form-control" placeholder="Anything in particular we should know about what you need? Please let us know if you would like a fun bag!"></textarea>
          <hr>
          <button class="mylisting-button dark-button" @click="postJob()">Create Request</button>
        </div>
      </div>
      <div class="col-lg-8 calendar" style="min-height: 550px;">
        <calendar-view
          :show-date="showDate"
          class="theme-default holiday-us-traditional holiday-us-official"
          @click-date="onClickDate"
          :date-classes="selectedDateObj"
          :events="calendarJobs"
          @click-event="onClickEvent"
        >
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate"
          />
        </calendar-view>
      </div>
    </div>

    <modal name="job-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <!-- <h2>Status updated.</h2> -->
        <!-- {{ job }} -->
        <h4>{{ new Date(job.date).toDateString() }}</h4>
        <hr>
        <p class="mb-2">Status: {{ job.status }}</p>
        <p>Start Time: {{ djangotimeformatAMPM(job.start_time) }}</p>
        <p>End Time: {{ djangotimeformatAMPM(job.end_time) }}</p>
        <pre v-if="job.text">Notes: {{ job.text }}</pre>
        <div v-if="job.status != 'Requested'">
          <hr>
          <p style="font-style: italic;">We are currently processing your request. If you really need to change it please contact us immediately (a cancellation fee may be required).</p>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('job-modal')" style="">Close</button>
        <button v-if="job.status == 'Requested'" class="mylisting-button danger-button" @click="$modal.show('delete-job-modal')" style="float: right;">Delete</button>
      </div>
    </modal>

    <modal name="request-submitted-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Your request has been submitted.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('request-submitted-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-job-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Are you sure you want to delete this request?</h3>
        <!-- <p>{{ user.first_name }} {{ user.last_name }}</p> -->
        <!-- <p>{{ user.email }}</p> -->
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-job-modal')" style="">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteJob()" style="float: right;">Delete</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");

export default {
  props: ['user'],
  components: {
    CalendarView,
    CalendarViewHeader
  },
  data () {
    return {
      showDate: new Date(),
      selectedDateObj: {},

      selectedDate: null,
      selectedFilterEmployer: "", //v-model to employer Email

      // startHour: 'HH',
      // startMinute: 'MM',
      // startHour: '01',
      startHour: 1,
      startMinute: '00',
      startAMPM: 'AM',
      startTime: null,
      // endHour: '01',
      endHour: 1,
      endMinute: '00',
      endTime: null,
      endAMPM: 'AM',

      // hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      // hourOptions: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      // hourOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      ampmOptions: ['AM', 'PM'],

      notes: '',
      preferredNanny: '',

      // events: [{id: 0, startDate: '2020-04-5 09:00:00', title: 'Goel Family'}, {id: 1, startDate: '2020-04-12 09:00:00', title: 'Goel Family'}, {id: 2, startDate: '2020-04-19 09:00:00', title: 'Goel Family'}],

      jobs: [],
      calendarJobs: [],
      job: {},
    }
  },
  created() {
    this.getJobs()
  },
  methods: {
    setShowDate(d) {
      this.showDate = d;
    },
    onClickDate(d) {
      console.log('date clicked')
      console.log(d)
      this.selectedDate = d

      this.startHour = 1
      this.startMinute = '00'
      this.startAMPM = 'AM'
      // startTime: null,
      // endHour: '01',
      this.endHour = 1
      this.endMinute = '00'
      // this.endTime = null
      this.endAMPM = 'AM'

      this.notes = ''

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    onClickEvent(event) {
      console.log(event)
      axios.get(`/api/jobs/?id=${event.id}`)
        .then(res => {
          console.log(res)
          this.job = res.data[0]
          this.$modal.show('job-modal')
        })
    },
    getJobs() {
      axios.get(`/api/jobs/?poster=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.jobs = res.data

          this.calendarJobs = []
          for (var job in this.jobs) {
            console.log('dsgjaklsjl;kds')
            // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
            this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    postJob() {
      console.log('Posting job')

      this.startHour = parseInt(this.startHour)
      if (this.startHour == 12) {
        this.startHour -= 12
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        console.log(this.startHour)
        this.startHour += 12
        console.log(this.startHour)
      }
      this.startHour = ("0" + this.startHour).slice(-2);
      console.log(this.startHour)

      this.endHour = parseInt(this.endHour)
      if (this.endHour == 12) {
        this.endHour -= 12
      }
      // else {
      //   this.endHour -= 1
      // }
      if (this.endAMPM == 'PM') {
        this.endHour += 12
      }
      this.endHour = ("0" + this.endHour).slice(-2);

      // this.events.push({id: 4, startDate: this.selectedDate, title: 'Enginehire Family'})
      axios.post('/api/jobs/', {
        poster: this.user.id,
        poster_name: this.user.employer_name,
        date: this.dateInDjangoFormat(this.selectedDate),
        // start_time: this.convertTimeFormat(`${this.startHour}:${this.startMinute}${this.startAMPM}`),
        // end_time: this.convertTimeFormat(`${this.endHour}:${this.endMinute}${this.endAMPM}`),
        start_time: `${this.startHour}:${this.startMinute}:00`,
        end_time: `${this.endHour}:${this.endMinute}:00`,
        text: this.notes,
        text2: this.preferredNanny,
        status: 'Requested',

        address1: this.user.address1,
        address2: this.user.address2,
        postal_code: this.user.postal_code,
        city: this.user.city,
        provincestate: this.user.provincestate,
        country: this.user.country,
        multiselect1: this.user.features2, // Array with info about children

        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          console.log(res)
          this.getJobs()
          this.$modal.show('request-submitted-modal')
          this.selectedDate = null
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteJob() {
      axios.delete(`/api/jobs/${this.job.id}`)
        .then(res => {
          console.log(res)
          this.getJobs()
          this.$modal.hide('job-modal')
          this.$modal.hide('delete-job-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/jobs/Scheduler.vue